<div class="custom-quill">
    <quill-editor (onContentChanged)="textChanged($event)" [modules]="modules" [formControl]="control" [filterNull]="true" placeholder=" "></quill-editor>
</div>
